import { render, staticRenderFns } from "./moduleDetail.vue?vue&type=template&id=1715b60c&"
import script from "./moduleDetail.vue?vue&type=script&lang=js&"
export * from "./moduleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports